export const organizationType = {
  sp: 'SP',
  si: 'SI',
  org: 'ORGANIZATION',
  tag: 'STORETAG',
  site: 'STORE'
}